import React from "react";

import { HubDialogWrapper } from "../HubDialogWrapper";
import CreateCompanyContent from "./CreateCompanyContent";

export const CreateCompany = ({ isVendor }) => {
  return (
    <HubDialogWrapper maxWidth="sm" name="create-company">
      <CreateCompanyContent isVendor={isVendor} />
    </HubDialogWrapper>
  );
};

export default CreateCompany;
